import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from '@zurich/common/hooks';
import { PageLoader } from '@zurich/ui/molecules';
import { useAppInstance, useNextAppSession } from '../../hooks';
export function AuthWrapperPrivate({ children }) {
    const { t } = useTranslation();
    const { signIn } = useAppInstance();
    const { status: sessionStatus, refreshInProgress } = useNextAppSession();
    useEffect(() => {
        if (sessionStatus === 'unauthenticated') {
            void signIn();
        }
    }, [sessionStatus, signIn]);
    if (sessionStatus !== 'authenticated' && !refreshInProgress) {
        return (_jsx(PageLoader, { height: "400px", width: "400px", loadingText: t('nextapp:authRedirect.signin') }));
    }
    return _jsx(_Fragment, { children: children });
}
